"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AllAddons = exports.PrimaryAddons = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _Editions = require("self-service-api/constants/Editions");

var _editionSpecificMerch, _editionSpecificMerch2, _Hubs$HUB_MARKETING$H;

var PrimaryAddons = [_MerchandiseIds.ADDON_REPORTING, _MerchandiseIds.ADDON_ADS_CAPACITY, _MerchandiseIds.ADDON_CUSTOM_SSL, _MerchandiseIds.ADDON_API];
exports.PrimaryAddons = PrimaryAddons;
var AllAddons = [_MerchandiseIds.ADDON_ADS_CAPACITY, _MerchandiseIds.ADDON_API, _MerchandiseIds.ADDON_CUSTOM_SSL, _MerchandiseIds.ADDON_DEDICATED_IP, _MerchandiseIds.ADDON_REPORTING, _MerchandiseIds.ADDON_TRANSACTIONAL_EMAIL, _MerchandiseIds.ADDON_BRAND_DOMAIN];
exports.AllAddons = AllAddons;

var _default = (_Hubs$HUB_MARKETING$H = {}, (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_MARKETING, {
  primaryMerch: PrimaryAddons,
  editionSpecificMerchMap: (_editionSpecificMerch = {}, (0, _defineProperty2.default)(_editionSpecificMerch, _Editions.PROFESSIONAL, [_MerchandiseIds.ADDON_DEDICATED_IP, _MerchandiseIds.ADDON_TRANSACTIONAL_EMAIL]), (0, _defineProperty2.default)(_editionSpecificMerch, _Editions.ENTERPRISE, [_MerchandiseIds.ADDON_DEDICATED_IP, _MerchandiseIds.ADDON_TRANSACTIONAL_EMAIL, _MerchandiseIds.ADDON_BRAND_DOMAIN]), _editionSpecificMerch)
}), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_SALES, {
  primaryMerch: PrimaryAddons
}), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_SERVICE, {
  primaryMerch: PrimaryAddons
}), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, 'growth-suite', {
  primaryMerch: PrimaryAddons,
  editionSpecificMerchMap: (_editionSpecificMerch2 = {}, (0, _defineProperty2.default)(_editionSpecificMerch2, _Editions.PROFESSIONAL, [_MerchandiseIds.ADDON_DEDICATED_IP, _MerchandiseIds.ADDON_TRANSACTIONAL_EMAIL]), (0, _defineProperty2.default)(_editionSpecificMerch2, _Editions.ENTERPRISE, [_MerchandiseIds.ADDON_DEDICATED_IP, _MerchandiseIds.ADDON_TRANSACTIONAL_EMAIL, _MerchandiseIds.ADDON_BRAND_DOMAIN]), _editionSpecificMerch2)
}), _Hubs$HUB_MARKETING$H);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./js/constants/HubToAddonsMap.js
// module id = 220
// module chunks = 5 6 7